import { OnInit, Injectable } from '@angular/core';

// import {WallHolesService} from '../../../services/wall/wall-holes.service';
import { ObjectCheckerService } from '../../../../services/object-checker.service';
import { IHandler } from './IHandler';
import { Select3dService } from '../../../../services/select-3d.service';
import { EventLogService, Actions } from '../../../../services/eventLog';

declare const THREE: any;

@Injectable()
export class DeleteHandler implements IHandler {
  name: string;

  constructor(
    private Select3D: Select3dService,
    // protected wallHoles: WallHolesService,
    protected objectCheckerSrvc: ObjectCheckerService,
    private eventLog: EventLogService
  ) {
    this.name = 'delete';
  }

  invoke(selected) {
    let i = 0;
    let object;

    if (!Array.isArray(selected)) selected = [selected];

    for (; i < selected.length; i++) {
      object = selected[i];
      // wallName = container.userData.wall;
      if (!object) continue;
      this.eventLog.dispatch(new Actions.ObjectDeleteAction(object));
    }

    // this.wallHoles.update(wallName);

    return false;
  }

  canExecute = (objects: any[]) => objects.length !== 0;
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectControls/Handlers/DeleteHandler.ts